import { useParams } from "react-router-dom";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { Sites } from "data/utils/globals";
import useGetItem from "./hooks/useGetItem";
import useUpdate from "./hooks/useUpdate";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { Permissions } from "./index";

function Update() {
  const id = Number(useParams()?.id);

  if (!id) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath={"/uniftec/cancelamento"}
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
      hideDeleteButton
      updatePermission={Permissions.update}
    />
  );
}

export default Update;
